export const direction = { none: 'None', one: 'One', both: 'Both' };
